import { AdTypes } from '@bingads-webui-campaign-react/campaign-onboarding-v2';

export const STEP_PATHS = {
  DISPLAY_AD: 'DISPLAY_AD',
  VIDEO_AD: 'VIDEO_AD',
  NATIVE_AD: 'NATIVE_AD',
  MULTI_NATIVE_AD: 'MULTI_NATIVE_AD',
  MULTI_AD_MANAGER: 'MULTI_AD_MANAGER',
  AD_GROUP: 'AD_GROUP',
  AD_GROUP_CREATION: 'AD_GROUP_CREATION',
  CAMPAIGN_CREATION: 'CAMPAIGN_CREATION',
  CAMPAIGN_EDIT: 'CAMPAIGN_EDIT',
  SUMMARY: 'SUMMARY',
};

export const FLOWS = {
  DISPLAY_CAMPAIGNS: 'DISPLAY_CAMPAIGNS',
  VIDEO_CAMPAIGNS: 'VIDEO_CAMPAIGNS',
  AUDIENCE_CAMPAIGNS: 'AUDIENCE_CAMPAIGNS',
  CTV_CAMPAIGNS: 'CTV_CAMPAIGNS',
  DEAL_CAMPAIGNS: 'DEAL_CAMPAIGNS',
  MULTI_AUDIENCE_CAMPAIGNS: 'MULTI_AUDIENCE_CAMPAIGNS',
  AUDIENCE_CAMPAIGN_EDIT: 'AUDIENCE_CAMPAIGN_EDIT',
  AUDIENCE_AD_GROUP_EDIT: 'AUDIENCE_AD_GROUP_EDIT',
  AUDIENCE_AD_GROUP_CREATION: 'AUDIENCE_AD_GROUP_CREATION',

  AUDIENCE_CAMPAIGN_CTV_EDIT: 'AUDIENCE_CAMPAIGN_CTV_EDIT',
  AUDIENCE_AD_GROUP_CTV_EDIT: 'AUDIENCE_AD_GROUP_CTV_EDIT',
  AUDIENCE_AD_GROUP_CTV_CREATION: 'AUDIENCE_AD_GROUP_CTV_CREATION',

  AUDIENCE_CAMPAIGN_DEAL_EDIT: 'AUDIENCE_CAMPAIGN_DEAL_EDIT',
  AUDIENCE_AD_GROUP_DEAL_CREATION: 'AUDIENCE_AD_GROUP_DEAL_CREATION',
  AUDIENCE_AD_GROUP_DEAL_EDIT: 'AUDIENCE_AD_GROUP_DEAL_EDIT',

  AUDIENCE_AD_GROUP_MULTI_AD_CREATION: 'AUDIENCE_AD_GROUP_MULTI_AD_CREATION',
};

export const AD_TYPES_TO_FLOWS = {
  [AdTypes.Display]: FLOWS.DISPLAY_CAMPAIGNS,
  [AdTypes.Video]: FLOWS.VIDEO_CAMPAIGNS,
  [AdTypes.Native]: FLOWS.AUDIENCE_CAMPAIGNS,
  [AdTypes.AudienceVideo]: FLOWS.CTV_CAMPAIGNS,
  [AdTypes.Netflix]: FLOWS.DEAL_CAMPAIGNS,
};

export const WIZARD_TYPES = {
  AUDIENCE_CAMPAIGN_EDIT: 'AUDIENCE_CAMPAIGN_EDIT',
  AUDIENCE_AD_GROUP_EDIT: 'AUDIENCE_AD_GROUP_EDIT',
  AUDIENCE_AD_GROUP_CREATION: 'AUDIENCE_AD_GROUP_CREATION',

  AUDIENCE_CAMPAIGN_CTV_EDIT: 'AUDIENCE_CAMPAIGN_CTV_EDIT',
  AUDIENCE_AD_GROUP_CTV_EDIT: 'AUDIENCE_AD_GROUP_CTV_EDIT',
  AUDIENCE_AD_GROUP_CTV_CREATION: 'AUDIENCE_AD_GROUP_CTV_CREATION',

  AUDIENCE_CAMPAIGN_DEAL_EDIT: 'AUDIENCE_CAMPAIGN_DEAL_EDIT',
  AUDIENCE_AD_GROUP_DEAL_EDIT: 'AUDIENCE_AD_GROUP_DEAL_EDIT',
  AUDIENCE_AD_GROUP_DEAL_CREATION: 'AUDIENCE_AD_GROUP_DEAL_CREATION',
};

export const WIZARD_TYPE_TO_FLOW = {
  [WIZARD_TYPES.AUDIENCE_CAMPAIGN_EDIT]: FLOWS.AUDIENCE_CAMPAIGN_EDIT,
  [WIZARD_TYPES.AUDIENCE_AD_GROUP_EDIT]: FLOWS.AUDIENCE_AD_GROUP_EDIT,
  [WIZARD_TYPES.AUDIENCE_AD_GROUP_CREATION]: FLOWS.AUDIENCE_AD_GROUP_CREATION,

  [WIZARD_TYPES.AUDIENCE_CAMPAIGN_CTV_EDIT]: FLOWS.AUDIENCE_CAMPAIGN_CTV_EDIT,
  [WIZARD_TYPES.AUDIENCE_AD_GROUP_CTV_EDIT]: FLOWS.AUDIENCE_AD_GROUP_CTV_EDIT,
  [WIZARD_TYPES.AUDIENCE_AD_GROUP_CTV_CREATION]: FLOWS.AUDIENCE_AD_GROUP_CTV_CREATION,

  [WIZARD_TYPES.AUDIENCE_CAMPAIGN_DEAL_EDIT]: FLOWS.AUDIENCE_CAMPAIGN_DEAL_EDIT,
  [WIZARD_TYPES.AUDIENCE_AD_GROUP_DEAL_EDIT]: FLOWS.AUDIENCE_AD_GROUP_DEAL_EDIT,
  [WIZARD_TYPES.AUDIENCE_AD_GROUP_DEAL_CREATION]: FLOWS.AUDIENCE_AD_GROUP_DEAL_CREATION,
};

export const FLOWS_TO_FIRST_STEP = {
  [FLOWS.DISPLAY_CAMPAIGNS]: STEP_PATHS.DISPLAY_AD,
  [FLOWS.VIDEO_CAMPAIGNS]: STEP_PATHS.VIDEO_AD,
  [FLOWS.CTV_CAMPAIGNS]: STEP_PATHS.VIDEO_AD,
  [FLOWS.DEAL_CAMPAIGNS]: STEP_PATHS.VIDEO_AD,
  [FLOWS.AUDIENCE_CAMPAIGNS]: STEP_PATHS.NATIVE_AD,
  [FLOWS.MULTI_AUDIENCE_CAMPAIGNS]: STEP_PATHS.MULTI_AD_MANAGER,
  [FLOWS.AUDIENCE_CAMPAIGN_EDIT]: STEP_PATHS.CAMPAIGN_EDIT,
};

export const isAudienceCampaign = flow => flow === FLOWS.AUDIENCE_CAMPAIGNS || flow === FLOWS.MULTI_AUDIENCE_CAMPAIGNS;

export const isAudienceCampaignEdit = flow => flow === FLOWS.AUDIENCE_CAMPAIGN_EDIT;
export const isCTVCampaignEdit = flow => flow === FLOWS.AUDIENCE_CAMPAIGN_CTV_EDIT;
export const isDealCampaignEdit = flow => flow === FLOWS.AUDIENCE_CAMPAIGN_DEAL_EDIT;

export const isAudienceAdGroupEdit = flow => flow === FLOWS.AUDIENCE_AD_GROUP_EDIT;
export const isDealAdGroupEdit = flow => flow === FLOWS.AUDIENCE_AD_GROUP_DEAL_EDIT;
export const isCTVAdGroupEdit = flow => flow === FLOWS.AUDIENCE_AD_GROUP_CTV_EDIT;

export const isAudienceAdGroupCreation = flow => flow === FLOWS.AUDIENCE_AD_GROUP_CREATION;
export const isCTVAdGroupCreation = flow => flow === FLOWS.AUDIENCE_AD_GROUP_CTV_CREATION;
export const isDealAdGroupCreation = flow => flow === FLOWS.AUDIENCE_AD_GROUP_DEAL_CREATION;

export const isAudienceAdGroupMultiAdCreation = flow => flow === FLOWS.AUDIENCE_AD_GROUP_MULTI_AD_CREATION;

export const isAudience = flow => isAudienceCampaign(flow) ||
  isAudienceCampaignEdit(flow) ||
  isAudienceAdGroupCreation(flow) ||
  isAudienceAdGroupMultiAdCreation(flow) ||
  isAudienceAdGroupEdit(flow);

// Note: Update these functions when adding ad group creation and editing to display and video.
export const isAdGroupCreation = flow => isAudienceAdGroupCreation(flow);
export const isEdit = flow => isAudienceCampaignEdit(flow) || isAudienceAdGroupEdit(flow) || isCTVCampaignEdit(flow) || isCTVAdGroupEdit(flow) || isDealCampaignEdit(flow) || isDealAdGroupEdit(flow);

export const isMultiAdsAudienceCampaign = flow => flow === FLOWS.MULTI_AUDIENCE_CAMPAIGNS || flow === FLOWS.AUDIENCE_AD_GROUP_CREATION;

export const isDisplayAdsCampaign = flow => flow === FLOWS.DISPLAY_CAMPAIGNS;

export const isVideoAdsCampaign = flow => flow === FLOWS.VIDEO_CAMPAIGNS;

export const isCTVCampaign = flow => flow === FLOWS.CTV_CAMPAIGNS || isCTVCampaignEdit(flow) || isCTVAdGroupEdit(flow) || isCTVAdGroupCreation(flow);
export const isDealCampaign = flow => flow === FLOWS.DEAL_CAMPAIGNS || isDealCampaignEdit(flow) || isDealAdGroupEdit(flow) || isDealAdGroupCreation(flow);
export const isCTVOrDeal = flow => isCTVCampaign(flow) || isDealCampaign(flow);

export const shouldEnableBidAdjustment = (flow, serverContext) => {
  const {
    DynamicPermissions: {
      EnableMSANDisplayCampaigns,
      EnableMSANVideoCampaigns,
    },
  } = serverContext;

  const isMSANDisplay = EnableMSANDisplayCampaigns && flow === FLOWS.DISPLAY_CAMPAIGNS;
  const isMSANVideo = EnableMSANVideoCampaigns && flow === FLOWS.VIDEO_CAMPAIGNS;

  if (isAudienceCampaign(flow) || isMSANDisplay || isMSANVideo) {
    if (serverContext.Permissions.IsAmplifyEnabled) {
      return false;
    }
    return true;
  }
  return false;
};
